export const SITE_NAME = "Help Genie";
export const SITE_URL = "https://helpgenie.ai";
export const DEFAULT_OG_IMAGE = `${SITE_URL}/helpgenie_logo.png`;

export const getCanonicalUrl = (path: string = "/") => {
  if (path.startsWith("http://") || path.startsWith("https://")) {
    return path;
  }

  const normalizedPath = path.startsWith("/") ? path : `/${path}`;
  return `${SITE_URL}${normalizedPath}`;
};

/**
 * Industries with a dedicated static landing page on the Astro marketing
 * site (helpgenie-landing-pages, proxied at helpgenie.ai/{slug}). Those
 * pages are faster and far more complete than the SPA /solutions/:slug
 * route, so every internal link should point straight at them instead of
 * shipping two competing URLs for the same industry — that duplication is
 * what was causing Google to collapse and mis-canonicalize both pages.
 */
export const LANDING_PAGE_INDUSTRIES = new Set([
  "appliances",
  "automotive",
  "events",
  "home-builders",
  "industrial",
  "manufacturing",
  "marine",
  "office-equipment",
  "real-estate",
  "trades",
  "travel-hospitality",
]);

/**
 * Resolves the correct internal href for an industry/solution slug: the
 * static Astro landing page when one exists, otherwise the SPA
 * /solutions/:slug route. Use this everywhere a solution/industry link is
 * built instead of hardcoding `/solutions/${slug}`.
 */
export const getIndustryHref = (slug: string) =>
  LANDING_PAGE_INDUSTRIES.has(slug) ? `/${slug}` : `/solutions/${slug}`;

/** Canonical URL for an industry — always the Astro landing page when one exists. */
export const getIndustryCanonicalUrl = (slug: string) =>
  getCanonicalUrl(LANDING_PAGE_INDUSTRIES.has(slug) ? `/${slug}/` : `/solutions/${slug}`);
